(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sevicho-fly-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.querySelector('[data-sv-fly-root]');
    if (!root) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function findCartIcon() {
      return (
        document.querySelector('[data-sv-cart-icon]') ||
        document.querySelector('.header__icon--cart') ||
        document.querySelector('.cart-icon') ||
        document.querySelector('a[href$="/cart"]') ||
        document.querySelector('[data-cart-icon]')
      );
    }

    function findSourceImage(evt) {
      // explicit source from event detail
      const passed = evt && evt.detail && evt.detail.source;
      if (passed instanceof Element) {
        const img = passed.tagName === 'IMG' ? passed : passed.querySelector('img');
        if (img) return img;
      }
      // fall back to visible quick-view hero image
      const qvImg = document.querySelector('.sv-qv__dialog[open] [data-sv-qv-media] img');
      if (qvImg) return qvImg;
      // then the first card image the user is hovering
      const hovered = document.querySelector('.sv-card:hover img, .sevicho-card:hover img, .sv-rv__card:hover img');
      if (hovered) return hovered;
      return null;
    }

    function rectCenter(el) {
      const r = el.getBoundingClientRect();
      return { x: r.left + r.width / 2, y: r.top + r.height / 2, rect: r };
    }

    function pulseCart(icon) {
      if (!icon) return;
      icon.setAttribute('data-sv-pulsing', '1');
      setTimeout(() => icon.removeAttribute('data-sv-pulsing'), 600);
    }

    function spawnBurst(x, y) {
      if (reduced) return;
      // Rose ring
      const ring = document.createElement('span');
      ring.className = 'sv-fly-burst';
      ring.style.left = (x - 27) + 'px';
      ring.style.top = (y - 27) + 'px';
      document.body.appendChild(ring);
      // Butter echo
      const echo = document.createElement('span');
      echo.className = 'sv-fly-burst sv-fly-burst--echo';
      echo.style.left = (x - 27) + 'px';
      echo.style.top = (y - 27) + 'px';
      document.body.appendChild(echo);
      // Caveat "yay!"
      const words = ['yay!', 'got it', 'bag it', '+1', 'nice'];
      const word = words[Math.floor(Math.random() * words.length)];
      const yay = document.createElement('span');
      yay.className = 'sv-fly-yay';
      yay.textContent = word;
      yay.style.left = x + 'px';
      yay.style.top = (y - 22) + 'px';
      document.body.appendChild(yay);

      setTimeout(() => { ring.remove(); echo.remove(); }, 900);
      setTimeout(() => yay.remove(), 1000);
    }

    function animate(sourceImg, cartIcon) {
      if (reduced) {
        pulseCart(cartIcon);
        return;
      }
      if (!sourceImg || !cartIcon || !(sourceImg instanceof Element)) {
        pulseCart(cartIcon);
        return;
      }

      const start = rectCenter(sourceImg);
      const end = rectCenter(cartIcon);

      const ghost = document.createElement('div');
      ghost.className = 'sv-fly-ghost';
      const img = document.createElement('img');
      img.src = sourceImg.currentSrc || sourceImg.src;
      img.alt = '';
      ghost.appendChild(img);
      ghost.style.left = (start.x - 36) + 'px';
      ghost.style.top = (start.y - 36) + 'px';
      document.body.appendChild(ghost);

      const dx = end.x - start.x;
      const dy = end.y - start.y;

      // Animate via Web Animations API for a clean curve + scale-down + little wobble
      const animation = ghost.animate([
        { transform: 'translate3d(0, 0, 0) scale(1) rotate(0deg)', offset: 0, opacity: 1 },
        { transform: 'translate3d(' + (dx * 0.55) + 'px, ' + (dy * 0.2 - 80) + 'px, 0) scale(0.8) rotate(-8deg)', offset: 0.45, opacity: 1 },
        { transform: 'translate3d(' + dx + 'px, ' + dy + 'px, 0) scale(0.15) rotate(12deg)', offset: 1, opacity: 0.2 }
      ], {
        duration: 720,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        fill: 'forwards'
      });

      animation.onfinish = () => {
        ghost.remove();
        pulseCart(cartIcon);
        spawnBurst(end.x, end.y);
      };
      // Safety timeout in case onfinish doesn't fire
      setTimeout(() => { if (ghost.isConnected) ghost.remove(); }, 1600);
    }

    document.addEventListener('sevicho:cart:added', (evt) => {
      const cartIcon = findCartIcon();
      const source = findSourceImage(evt);
      animate(source, cartIcon);
    });

    // Also pulse on generic cart:updated events (if other scripts fire them)
    document.addEventListener('sevicho:cart:updated', () => {
      const cartIcon = findCartIcon();
      pulseCart(cartIcon);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sevicho-pdp-bundle-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
    var packs = document.querySelectorAll('[data-sv-pack]');
    if (!packs.length) return;

    function formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency || 'USD'
        }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function findShopifyForm() {
      return document.querySelector('product-form form, form[action*="/cart/add"]');
    }

    // The PRIMARY ATC button — the one inside the real form. We use this for
    // form-submission listening. There may also be a sticky ATC mirror
    // (.PDP__stk__mainwrapper) and other duplicates outside the form; their
    // labels are updated separately so they stay in sync visually.
    function findPrimaryAtcButton(form) {
      if (!form) return null;
      return form.querySelector('button[type="submit"][name="add"], .product-form__submit');
    }

    // Every visible ATC label on the page (main, sticky, dynamic mirrors) so a
    // pack change updates ALL of them at once.
    function findAllAtcLabels() {
      var nodes = document.querySelectorAll(
        'product-form button[type="submit"][name="add"] span, ' +
        '.product-form__submit > span, ' +
        '.PDP__stk__mainwrapper .product-form__submit > span'
      );
      // De-dupe by node reference
      var seen = new Set ? new Set() : null;
      var out = [];
      nodes.forEach(function (n) {
        if (seen) {
          if (seen.has(n)) return;
          seen.add(n);
        }
        out.push(n);
      });
      return out;
    }

    packs.forEach(function (pack) {
      var currency = pack.dataset.currency || 'USD';
      var opts = pack.querySelectorAll('[data-sv-opt]');
      var radios = pack.querySelectorAll('input[type="radio"]');

      var form = findShopifyForm();
      var atcBtn = findPrimaryAtcButton(form);

      // Inject a hidden quantity input into the Shopify form so submits carry
      // the right qty. Most Showcase product forms default to qty=1 with no
      // visible input — this gives us a single source of truth for qty.
      var qtyInput = null;
      if (form) {
        qtyInput = form.querySelector('input[name="quantity"]');
        if (!qtyInput) {
          qtyInput = document.createElement('input');
          qtyInput.type = 'hidden';
          qtyInput.name = 'quantity';
          form.appendChild(qtyInput);
        }
      }

      function applySelection(opt) {
        opts.forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');

        var qty = parseInt(opt.dataset.packQty, 10) || 1;
        var packCents = parseInt(opt.dataset.packCents, 10) || 0;
        var label = opt.dataset.packLabel || 'pack';

        // Update Shopify form quantity
        if (qtyInput) qtyInput.value = qty;

        // Update EVERY visible ATC label on the page (main + sticky mirror)
        // so the buy CTA always reflects the active pack selection.
        var ctaText = (qty === 1)
          ? 'Add to cart · ' + formatMoney(packCents, currency)
          : 'Add ' + label + ' · ' + formatMoney(packCents, currency);
        findAllAtcLabels().forEach(function (labelEl) {
          labelEl.textContent = ctaText;
        });
      }

      // Wire up the radios
      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          var opt = radio.closest('[data-sv-opt]');
          if (opt) applySelection(opt);
        });
      });

      // Allow clicking anywhere on the card label to select (default <label>
      // behavior). Already wired by the <label> wrapping the radio.

      // Initial sync: trigger the default-checked radio's selection logic
      var initial = pack.querySelector('input[type="radio"]:checked');
      if (initial) {
        var initialOpt = initial.closest('[data-sv-opt]');
        if (initialOpt) applySelection(initialOpt);
      }

      // Also ensure that any form submission carries the quantity, even if
      // some other code resets it. Listen on the form's submit event.
      if (form) {
        form.addEventListener('submit', function () {
          var checked = pack.querySelector('input[type="radio"]:checked');
          if (checked) {
            var opt = checked.closest('[data-sv-opt]');
            if (opt && qtyInput) {
              qtyInput.value = parseInt(opt.dataset.packQty, 10) || 1;
            }
          }
        }, true); // capture phase so we run before product-form's listener
      }

      // Sticky ATC forwarder lives in sections/pdp-main-product.liquid
      // (see the DOMContentLoaded block near the end of that file). It
      // runs unconditionally on every PDP — including non-bundle SKUs —
      // and is null-safe. We don't attach a second forwarder here; the
      // form-submit listener above is enough to re-affirm the right qty
      // when the sticky button programmatically triggers the form
      // submit on bundle products.
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sevicho-quick-view"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__svQuickViewInit) return;
    window.__svQuickViewInit = true;

    function money(cents, currency) {
      try {
        return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency || 'USD' });
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function getVariants(dialog) {
      var script = dialog.querySelector('[data-sv-qv-variants]');
      if (!script) return [];
      try { return JSON.parse(script.textContent); } catch (e) { return []; }
    }

    function selectedOptions(form) {
      var inputs = form.querySelectorAll('[data-sv-qv-option]:checked');
      return Array.prototype.slice.call(inputs)
        .sort(function (a, b) {
          return parseInt(a.getAttribute('data-sv-qv-option-position'), 10) -
                 parseInt(b.getAttribute('data-sv-qv-option-position'), 10);
        })
        .map(function (i) { return i.value; });
    }

    function findVariant(variants, selected) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++) {
          if (v.options[j] !== selected[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function currencyFor() {
      var el = document.querySelector('[data-currency]') ||
               document.querySelector('[data-currency-code]') ||
               document.querySelector('[data-cart-currency]');
      if (el) return el.getAttribute('data-currency') || el.getAttribute('data-currency-code') || el.getAttribute('data-cart-currency');
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) return window.Shopify.currency.active;
      return 'USD';
    }

    // Scroll-lock while any quick-view is open. Pinning the <html> element
    // keeps the user's visual position anchored — on mobile this is the
    // difference between "the sheet opens where I am" and "the page jumps
    // to the top the moment I tap quick view".
    var __svQvOpenCount = 0;
    var __svQvSavedScrollY = 0;

    function lockScroll() {
      if (__svQvOpenCount === 0) {
        __svQvSavedScrollY = window.scrollY || window.pageYOffset || 0;
        document.documentElement.style.setProperty('--sv-qv-saved-scroll', __svQvSavedScrollY + 'px');
        document.documentElement.style.position = 'fixed';
        document.documentElement.style.top = -__svQvSavedScrollY + 'px';
        document.documentElement.style.left = '0';
        document.documentElement.style.right = '0';
        document.documentElement.style.width = '100%';
      }
      __svQvOpenCount++;
    }

    function unlockScroll() {
      __svQvOpenCount = Math.max(0, __svQvOpenCount - 1);
      if (__svQvOpenCount === 0) {
        document.documentElement.style.position = '';
        document.documentElement.style.top = '';
        document.documentElement.style.left = '';
        document.documentElement.style.right = '';
        document.documentElement.style.width = '';
        document.documentElement.style.removeProperty('--sv-qv-saved-scroll');
        window.scrollTo(0, __svQvSavedScrollY);
      }
    }

    function openDialog(id) {
      var dialog = document.getElementById(id);
      if (!dialog) return;
      lockScroll();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }

    function closeDialog(id) {
      var dialog = document.getElementById(id);
      if (!dialog) return;
      // Scroll unlock happens in the `close` event handler below — that way
      // ESC-key closes, backdrop clicks, and the post-ATC auto-close all
      // restore scroll too, not just the close button.
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    // Single delegated listener for the native `close` event on all
    // quick-view dialogs — fires regardless of what closed them.
    document.querySelectorAll('dialog.sv-qv').forEach(function (d) {
      d.addEventListener('close', unlockScroll);
    });

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-sv-qv-open]');
      if (opener) {
        e.preventDefault();
        openDialog(opener.getAttribute('data-sv-qv-open'));
        return;
      }
      var closer = e.target.closest('[data-sv-qv-close]');
      if (closer) {
        e.preventDefault();
        closeDialog(closer.getAttribute('data-sv-qv-close'));
        return;
      }
    });

    document.addEventListener('click', function (e) {
      var dialog = e.target.closest('dialog.sv-qv');
      if (!dialog) return;
      var dec = e.target.closest('[data-sv-qv-dec]');
      var inc = e.target.closest('[data-sv-qv-inc]');
      if (!dec && !inc) return;
      e.preventDefault();
      var input = dialog.querySelector('[data-sv-qv-qty]');
      if (!input) return;
      var q = parseInt(input.value, 10) || 1;
      if (dec) q = Math.max(1, q - 1);
      if (inc) q = q + 1;
      input.value = q;
    });

    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-sv-qv-option]')) return;
      var dialog = e.target.closest('dialog.sv-qv');
      if (!dialog) return;
      var form = dialog.querySelector('[data-sv-qv-form]');
      if (!form) return;
      var variants = getVariants(dialog);
      var variant = findVariant(variants, selectedOptions(form));
      var label = form.querySelector('[data-sv-qv-selected="' + e.target.getAttribute('data-sv-qv-option-position') + '"]');
      if (label) label.textContent = e.target.value;

      var cur = currencyFor();
      var priceNow = dialog.querySelector('[data-sv-qv-price-now]');
      var compare = dialog.querySelector('[data-sv-qv-compare]');
      var atc = dialog.querySelector('[data-sv-qv-atc]');
      var atcLabel = dialog.querySelector('[data-sv-qv-atc-label]');
      var idInput = dialog.querySelector('[data-sv-qv-variant-id]');

      if (!variant) {
        if (atc) { atc.disabled = true; atc.setAttribute('aria-disabled', 'true'); }
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceNow) priceNow.textContent = money(variant.price, cur);
      if (compare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.hidden = false;
          compare.textContent = money(variant.compare_at_price, cur);
        } else {
          compare.hidden = true;
        }
      }
      if (atc && atcLabel) {
        if (variant.available) {
          atc.disabled = false;
          atc.removeAttribute('aria-disabled');
          atcLabel.innerHTML = 'Add to cart &middot; <span data-sv-qv-atc-price>' + money(variant.price, cur) + '</span>';
        } else {
          atc.disabled = true;
          atc.setAttribute('aria-disabled', 'true');
          atcLabel.textContent = 'Sold out';
        }
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-sv-qv-form]');
      if (!form) return;
      e.preventDefault();
      var dialog = form.closest('dialog.sv-qv');
      var atc = form.querySelector('[data-sv-qv-atc]');
      var atcLabel = form.querySelector('[data-sv-qv-atc-label]');
      var originalHtml = atcLabel ? atcLabel.innerHTML : '';
      if (atc) atc.disabled = true;

      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          if (atc) atc.classList.add('is-added');
          if (atcLabel) atcLabel.textContent = 'Added to bag';
          var sourceImg = dialog ? dialog.querySelector('[data-sv-qv-media] img, .sv-qv__media img') : null;
          var variantInput = form.querySelector('[data-sv-qv-variant-id]');
          var qtyInput = form.querySelector('[name="quantity"]');
          document.dispatchEvent(new CustomEvent('sevicho:cart:added', {
            detail: {
              variantId: variantInput ? variantInput.value : null,
              quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
              source: sourceImg || (dialog ? dialog.querySelector('.sv-qv__media') : null)
            }
          }));
          setTimeout(function () {
            if (dialog) {
              if (typeof dialog.close === 'function') dialog.close();
              else dialog.removeAttribute('open');
            }
            if (atc) { atc.classList.remove('is-added'); atc.disabled = false; }
            if (atcLabel) atcLabel.innerHTML = originalHtml;
          }, 900);
        })
        .catch(function () {
          form.submit();
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sevicho-urgency"] && !Shopify.designMode) return;
  try {
    (function () {
    const roots = document.querySelectorAll('[data-sv-urgency]');
    if (!roots.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function flash(el) {
      if (!el || reduced) return;
      el.setAttribute('data-flash', '1');
      setTimeout(() => el.removeAttribute('data-flash'), 700);
    }

    function formatCountdown(ms) {
      if (ms <= 0) return '00h 00m';
      const hrs = Math.floor(ms / 3600000);
      const mins = Math.floor((ms % 3600000) / 60000);
      return String(hrs).padStart(2, '0') + 'h ' + String(mins).padStart(2, '0') + 'm';
    }

    function nextCutoff(hour) {
      const now = new Date();
      const cutoff = new Date(now);
      cutoff.setHours(hour, 0, 0, 0);
      if (cutoff <= now) {
        cutoff.setDate(cutoff.getDate() + 1);
      }
      return cutoff;
    }

    roots.forEach((root) => {
      const cutoffHour = parseInt(root.dataset.cutoffHour, 10);

      // ships-by live countdown.  The badge is only rendered by Liquid when
      // the cutoff is still ahead, and Liquid precomputes the initial
      // "Xh Ym" label so shoppers never see a "--" placeholder. We just keep
      // it ticking client-side and remove the badge once the cutoff passes.
      const ships = root.querySelector('[data-sv-ships]');
      if (ships && !isNaN(cutoffHour)) {
        const label = ships.querySelector('[data-sv-ships-countdown]');
        const cutoffToday = new Date();
        cutoffToday.setHours(cutoffHour, 0, 0, 0);

        const tick = () => {
          const remaining = cutoffToday.getTime() - Date.now();
          if (remaining <= 0) {
            ships.remove();
            clearInterval(interval);
            return;
          }
          if (label) label.textContent = formatCountdown(remaining);
        };
        tick();
        const interval = setInterval(tick, 30000);
      }

      // viewers slow pulse (±2 every 8-14s) for a lived-in feel
      const viewers = root.querySelector('[data-sv-viewers]');
      if (viewers && !reduced) {
        const base = parseInt(viewers.dataset.base, 10) || 6;
        const qty = viewers.querySelector('[data-sv-viewers-count]');
        const drift = () => {
          const delta = Math.floor(Math.random() * 5) - 2;
          const next = Math.max(3, Math.min(24, base + delta));
          if (qty && qty.textContent !== String(next)) {
            qty.textContent = next;
            flash(viewers);
          }
        };
        const schedule = () => {
          const wait = 8000 + Math.floor(Math.random() * 6000);
          setTimeout(() => { drift(); schedule(); }, wait);
        };
        schedule();
      }

      // recent-purchase tick upward every ~45-90s
      const recent = root.querySelector('[data-sv-recent]');
      if (recent && !reduced) {
        const qty = recent.querySelector('[data-sv-recent-count]');
        let value = parseInt(recent.dataset.base, 10) || 12;
        const schedule = () => {
          const wait = 45000 + Math.floor(Math.random() * 45000);
          setTimeout(() => {
            value += 1;
            if (value > 59) value = 3 + Math.floor(Math.random() * 10);
            if (qty) qty.textContent = value;
            flash(recent);
            schedule();
          }, wait);
        };
        schedule();
      }
    });

    // Live-update stock when cart events fire (one less unit available after ATC)
    document.addEventListener('sevicho:cart:added', (evt) => {
      const vid = evt.detail && evt.detail.variantId;
      if (!vid) return;
      document.querySelectorAll('[data-sv-urgency]').forEach((root) => {
        const stock = root.querySelector('[data-sv-stock]');
        if (!stock) return;
        const qty = stock.querySelector('[data-sv-stock-qty]');
        if (!qty) return;
        const n = parseInt(qty.textContent, 10);
        if (isNaN(n) || n <= 0) return;
        if (n - 1 <= 0) { stock.hidden = true; return; }
        qty.textContent = n - 1;
        flash(stock);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
